export enum MatchTab {
    ALL = 'all',
    LIVE = 'live',
    FINISHED = 'finished',
    NOTSTARTED = 'not_started',
    ODDS = 'odds',
    RANKING = 'ranking',
}
